import React__default from 'react';
import MessageBubble from '../../../MessageBubble/index.js';
import styles from './styles.css.js';
import SellableWithTitle from '../components/SellableWithTitle/index.js';

var SellableDetailPage = function SellableDetailPage(_a) {
  var message = _a.message,
      conversationStarterMessage = _a.conversationStarterMessage,
      sourcePage = _a.sourcePage;
  return React__default.createElement(MessageBubble, {
    message: message,
    fullWidth: true
  }, React__default.createElement("div", {
    className: styles.container
  }, React__default.createElement("div", {
    className: styles.innerMessageBubble
  }, React__default.createElement(SellableWithTitle, {
    sellable: sourcePage.sellable
  })), React__default.createElement("div", {
    className: styles.copyRow
  }, "I have a question about this:"), React__default.createElement("div", {
    className: styles.messageRow
  }, conversationStarterMessage)));
};

export default SellableDetailPage;
//# sourceMappingURL=index.js.map
